import { render, staticRenderFns } from "./PagePositionTemplate.vue?vue&type=template&id=f04560e8&"
import script from "./PagePositionTemplate.vue?vue&type=script&lang=js&"
export * from "./PagePositionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports